import styled from 'styled-components';

export const Banner = styled.div`
  margin-top: -149px;
  background: url('/MainBackground.jpg') no-repeat center center;
  background-size: cover;
  height: 757px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1279px) {
    margin-top: 0;
    /* 헤더(약 64px)를 제외한 뷰포트 전체 높이로 채워, 스크롤 전 하단(About) 미노출 */
    height: calc(100vh - 64px);
    min-height: 480px;
    padding: 0 20px;
    justify-content: center;
    text-align: center;
    /* 이미지 상단이 밝은 회색이라, 아래쪽(붉은 영역)만 보이도록 레이어별 지정 + 가독성 오버레이 */
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url('/MainBackground.jpg');
    background-repeat: no-repeat;
    background-position:
      center,
      center bottom;
    background-size:
      cover,
      auto 140%;
  }
`;

export const RegisterButton = styled.button`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.Red};
  width: 384px;
  max-width: 100%;
  height: 54px;
  border: none;
  cursor: pointer;
`;

export const Block = styled.div`
  border-radius: 20px;
  box-shadow: 13px 41px 48.34px 0px rgba(207, 207, 207, 0.19);
  padding: 45px 15px;
  display: flex;
  flex-direction: column;
  gap: 23px;
  width: 382px;
  max-width: 100%;
  min-height: 204px;
  box-sizing: border-box;
  align-items: center;

  /* 모바일에선 텍스트가 여러 줄로 늘어나므로 고정 높이를 풀어 카드가 내용에 맞게 커지도록 */
  @media (max-width: 1279px) {
    height: auto;
    min-height: 180px;
    padding: 32px 20px;
    gap: 16px;
    justify-content: center;
  }
`;

export const Chip = styled.div`
  background: ${({ theme }) => theme.color.Red};
  border-radius: 36px;
  padding: 8px 12px;
  box-sizing: border-box;
`;
